import ImageUploading, {ImageType} from 'react-images-uploading'
import {useEffect, useState} from 'react'
import {BiPen, BiSave, BiTrash} from 'react-icons/bi'
import {useFormContext} from 'react-hook-form'
import {RealEstateLaunchFormData} from '../../../partials/typologies/formValidations'
import {useEmpreendimentos} from '../../../context/useEmpreendimentos'
import {deleteLaunchImages, updateLaunchImages} from '../../../../../../../services/urbit-gis'
import Swal from 'sweetalert2'

export function MediaCard() {
  const {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    formState: {errors},
  } = useFormContext<RealEstateLaunchFormData>()
  const {launch} = useEmpreendimentos()
  const [images, setImages] = useState<ImageType[]>([])
  // console.log(images);
  const maxNumber = 69

  useEffect(() => {
    if (launch && launch.images && typeof launch.images === 'object') {
      // Transforme o objeto em um array de ImageType
      const imageArray = Object.keys(launch.images).map((key, item) => {
        return {
          dataURL: launch.images[key],
          nome: key, // ou como você precisa mapear os valores
        }
      })
      setImages(imageArray)
    } else {
      setImages([])
    }
  }, [launch])

  const onChange = async (imageList: ImageType[], addUpdateIndex: number[]) => {
    const formData = new FormData()

    if (addUpdateIndex) {
      addUpdateIndex.forEach((item, index) => {
        formData.append('files', imageList[item].file)
      })
    }
    await updateLaunchImages(launch.id, formData)
    setImages(imageList)
    // }
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const uploadImages = async () => {
    const formData = new FormData()
    images.forEach((image, index) => {
      formData.append('files', image.file)
    })
    await updateLaunchImages(launch.id, formData)
  }

  const uploadDescricao = async (e, id) => {
    // const formData = new FormData()
    // let texto = e.target.value
    // images.forEach((image, index) => {
    //   formData.append('files', image.file)
    // })
    // const result = await updateLaunchImages(launch.id, formData)
    // console.log(result)
  }

  const onDelete = async (index) => {
    // const formData = new FormData()
    // images.forEach((image, index) => {
    //   formData.append('files', image.file)
    // })
    const result = await deleteLaunchImages(launch.id, index)

    if (result) {
      if (result.status === 200) {
        // console.log(Object.keys(result.data).length)
        // Transforme o objeto em um array de ImageType
        const imageArray = Object.keys(result.data).map((key, item) => {
          // console.log(key)
          // console.log(item)
          return {
            dataURL: launch.images[key],
            nome: key, // ou como você precisa mapear os valores
          }
        })
        // console.log('imageArray')
        // console.log(imageArray)
        Swal.fire('Imagem removida')
        setImages(imageArray)
      }
    } else {
      Swal.fire('Erro ao remover a imagem')
    }
  }
  // const onSubmit = async (data: TypologiesPriceFormData) => {
  //   try {
  //     const updatedData = { ...data, launch_price: checkboxValue ? 1 : 0 };
  //     const result = await updateTypologyPrice(id, updatedData)

  //     if (result && result.affected === 1) {
  //       Swal.fire({
  //         title: 'Sucesso!',
  //         text: id ? 'Preço atualizado com sucesso.' : 'Preço adicionado com sucesso.',
  //         icon: 'success',
  //         confirmButtonText: 'OK',
  //       }).then(() => {
  //         closeModal();
  //         reset();
  //         handleRefetch();
  //       });
  //     } else {
  //       throw new Error(result.message || 'Ocorreu um erro desconhecido');
  //     }
  //   } catch (error) {
  //     Swal.fire({
  //       title: 'Erro!',
  //       text: error.message || 'Houve um erro ao salvar o empreendimento.',
  //       icon: 'error',
  //       confirmButtonText: 'OK',
  //     });
  //   }
  // };

  return (
    <div className='card flex-grow-1 mb-5 mb-xl-8'>
      <div className='card-header border-0 pt-5'>
        <h2 className='fw-bolder pt-4 px-8 m-0'>Fotos e Videos</h2>
      </div>
      <div className='card-body py-3'>
        <div className='row px-0'>
          <div className='form-group col-md-12 form-line '>
            <div className='row'>
              <div className='col-md-12'>
                <ImageUploading
                  multiple
                  value={images}
                  onError={(error, images) => {
                    // console.log(error)
                    // console.log(images)
                  }}
                  onChange={onChange}
                  maxNumber={maxNumber}
                  acceptType={['jpg', 'png']}
                >
                  {({
                    imageList,
                    onImageUpload,
                    onImageRemoveAll,
                    onImageUpdate,
                    onImageRemove,
                    isDragging,
                    dragProps,
                    errors,
                  }) => (
                    <div className='w-100'>
                      <button
                        type='button'
                        className='btn btn-primary float-end'
                        style={isDragging ? {color: 'red'} : null}
                        onClick={onImageUpload}
                        {...dragProps}
                      >
                        Enviar fotos
                      </button>
                      {/* <button type='button' className='btn btn-info' onClick={()=>uploadDescricao()}>
                        Salvar descrições
                      </button> */}

                      <div className='upload__image-wrapper clearfix pt-15'>
                        {imageList.map((image, index) => {
                          return (
                            <div className='col-12 col-sm-4 col-xl-4 image-item' key={index}>
                              <div className='card h-250px'>
                                <div className='d-flex justify-content-center text-center flex-column'>
                                  <div className=' mb-2 h-150px   '>
                                    <img
                                      src={image.dataURL}
                                      alt=''
                                      className='img-fluid img-thumbnail border   border-hover border-gray-500'
                                      style={{maxHeight: 200}}
                                    />
                                  </div>
                                  <div className='fs-5 fw-bolder mb-2'>
                                    <input
                                      type='text'
                                      className='form-control'
                                      // value={image.nome}
                                      // defaultValue={image.nome}
                                      placeholder={image.nome}
                                    />
                                  </div>
                                  <div className='fs-7 fw-bold text-gray-500 mt-auto'>
                                    <div className='image-item__btn-wrapper'>
                                      <button
                                        type='button'
                                        className='btn btn-icon btn-sm btn-light-primary me-1'
                                        onClick={() => onImageUpdate(index)}
                                      >
                                        <BiPen />
                                      </button>
                                      <button
                                        type='button'
                                        className='btn btn-icon btn-light-danger  me-1'
                                        onClick={() => {
                                          onImageRemove(index)
                                          onDelete(index)
                                        }}
                                      >
                                        <BiTrash />
                                      </button>
                                      <button
                                        type='button'
                                        className='btn btn-icon btn-sm btn-light-primary me-1'
                                        onClick={(e) => uploadDescricao(e, index)}
                                      >
                                        <BiSave />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                      {errors && (
                        <div>
                          {errors.maxNumber && (
                            <span>Number of selected images exceed maxNumber</span>
                          )}
                          {errors.acceptType && <span>Your selected file type is not allow</span>}
                          {errors.maxFileSize && <span>Selected file size exceed maxFileSize</span>}
                          {errors.resolution && (
                            <span>Selected file is not match your desired resolution</span>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </ImageUploading>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
